<template>
  <div class="gs-app gs-aff-page gs-affiliate-bonuses">
    <header class="gs-aff-page__head"><div><h1>My bonuses</h1><p>Create extras for your audience, then attach them to your promotions.</p></div>
      <gs-button variant="primary" @click="openCreateBonus()"><gs-icon name="plus" size="16" />{{ $t('frontend_bouses_new_bonus') }}</gs-button>
    </header>
    <v-wait for="bonuses">
      <div class="gs-aff-toolbar gs-refresh-controls">
        <label class="gs-aff-toolbar__search">{{ $t('frontend_search') }}<input v-model="search" type="search" placeholder="Search bonuses" /></label>
        <label>Sort by<gd-dropdown v-model="selectedOrder" :options="sortOptions" /></label>
        <span class="gs-aff-count">{{ filteredBonuses.length }} {{ filteredBonuses.length === 1 ? 'bonus' : 'bonuses' }}</span>
      </div>
      <div v-if="filteredBonuses.length" class="gs-aff-bonus-grid">
        <article v-for="bonus in filteredBonuses" :key="bonus.id" class="gs-aff-link-card">
          <h3>{{ bonus.name }}</h3>
          <div class="gs-aff-link-card__row"><span class="gs-aff-link-card__url">{{ bonus.link }}</span>
            <div class="gs-aff-link-card__actions">
              <gs-button variant="outline" size="sm" :aria-label="'Edit ' + bonus.name" @click="openEditBonus(bonus.id)"><gs-icon name="edit" size="16" />{{ $t('frontend_groovesell_edit') }}</gs-button>
              <gs-button variant="ghost" size="icon" class="is-destructive" :title="$t('frontend_groovesell_delete_bonus')" :aria-label="'Delete ' + bonus.name" @click="openConfirmModal(bonus.id)"><gs-icon name="trash" size="16" /></gs-button>
            </div>
          </div>
        </article>
      </div>
      <p v-else class="gs-aff-empty">{{ search ? 'No bonuses match your search.' : $t('frontend_no_bonuses') }}</p>
      <create-bonus-modal :model="model" @createBonus="createBonus" />
      <edit-bonus-modal :model="model" @editBonus="editBonus" />
    </v-wait>
    <confirm-modal name="confirm-modal" :message-content="$t('frontend_bouses_delete_bonus_text')" :button-text="$t('frontend_bouses_delete_confirmation_text')" @confirm="deleteBonus" />
  </div>
</template>
<script>
import ConfirmModal from "./components/AffiliateConfirmModal.vue";
import './affiliate-workspace.css';
import Bonus from '@/models/Bonus';
import CreateBonusModal from './bonuses-partials/modals/CreateBonusModal.vue';
import EditBonusModal from './bonuses-partials/modals/EditBonusModal.vue';

export default {
  layout: 'defaultForAffiliates',
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('my_bonuses') };
  },
  components: {
    ConfirmModal,
    CreateBonusModal,
    EditBonusModal,
  },
  data() {
    return {
      bonusToDeleteId: null,
      bonus: null,
      bonuses: [],
      model: { name: '', link: '' },
      search: '',
      selectedOrder: 'default',
    };
  },

  computed: {
    sortOptions() {
      return [{ value: 'default', text: 'Default order' }, { value: 'name', text: 'Name (A-Z)' }, { value: '-name', text: 'Name (Z-A)' }];
    },
    filteredBonuses() {
      const query = this.search.trim().toLowerCase();
      const bonuses = this.bonuses.filter(bonus => String(bonus.name || '').toLowerCase().includes(query));
      if (this.selectedOrder === 'default') return bonuses;
      const direction = this.selectedOrder === '-name' ? -1 : 1;
      return bonuses.sort((a, b) => direction * String(a.name || '').localeCompare(String(b.name || '')));
    },
  },

  async created() {
    this.loadBonuses();
  },

  methods: {
    async loadBonuses() {
      this.$wait.start('bonuses');
      this.bonuses = await Bonus.$get();
      this.$wait.end('bonuses');
    },

    openCreateBonus() {
      this.resetBonusModel();
      this.$root.$emit('modal-open', 'create-bonus-modal');
    },

    async openEditBonus(bonus_id) {
      this.$loader.start('openEditBonus');
      this.bonus = await Bonus.$find(bonus_id);
      this.updateModelFromBonus();
      this.$loader.end('openEditBonus');
      this.$root.$emit('modal-open', 'edit-bonus-modal');
    },

    async createOrUpdateBonus(model, isCreate = true) {
      this.$loader.start('createOrUpdateBonus');
      this.model = model;
      this.bonus.name = this.model.name;
      this.bonus.link = this.model.link;

      const savedBonus = await this.bonus.save();

      if (isCreate) {
        this.bonuses.push(savedBonus.data);
      } else {
        this.bonuses = await Bonus.$get();
      }

      this.$loader.end('createOrUpdateBonus');
      this.$root.$emit('modal-close', isCreate ? 'create-bonus-modal' : 'edit-bonus-modal');
    },

    createBonus(model) {
      this.createOrUpdateBonus(model);
    },

    editBonus(model) {
      this.createOrUpdateBonus(model, false);
    },
    openConfirmModal(id) {
      this.$root.$emit('modal-open', 'confirm-modal');
      this.bonusToDeleteId = id;
    },
    async deleteBonus() {
      this.$loader.start('deleteBonus');
      const bonus = await Bonus.$find(this.bonusToDeleteId);
      await bonus.delete();
      this.bonuses = this.bonuses.filter(item => item.id !== this.bonusToDeleteId);
      this.$loader.end('deleteBonus');
    },

    resetBonusModel() {
      this.bonus = new Bonus({});
      this.model.name = '';
      this.model.link = '';
    },

    updateModelFromBonus() {
      this.model.name = this.bonus.name;
      this.model.link = this.bonus.link;
    },
  }
};
</script>
